import { Typography } from '@mui/material';
import { colors, PendingIcon } from '@truvhq/ui';

import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';
import { AuthStatusMessage } from 'shared/ui/AuthStatusMessage';

export const UnapprovedUser = () => {
  return (
    <AuthLayoutTemplate pageName="UnapprovedUser">
      <AuthStatusMessage
        title="Your account is under review"
        subtitle={
          <Typography color={colors.grey60} variant="body1">
            Truv will send you an email once your account is approved.
          </Typography>
        }
        icon={<PendingIcon viewBox="0 0 24 24" className="h-[40px] w-[40px] ml-[-8px] text-primary-main" />}
      />
    </AuthLayoutTemplate>
  );
};
